module.exports = __webpack_public_path__ + "img/icn_local.e4ff068e.svg";